import { render, staticRenderFns } from "./GenInspect.vue?vue&type=template&id=4ca28cf9&scoped=true"
import script from "./GenInspect.vue?vue&type=script&lang=js"
export * from "./GenInspect.vue?vue&type=script&lang=js"
import style0 from "./GenInspect.vue?vue&type=style&index=0&id=4ca28cf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca28cf9",
  null
  
)

export default component.exports